export const Messages = {
  validations: {
    required: "Obligatório",
    validEmail: "Debe ser un correo válido",
    minLenght: (len = 0) => `Mínimo ${len} caracteres`,
    higherThan: (n = 0) => `Debe ser mayor que ${n}`,
    lessThan: (n = 0) => `Debe ser menor que ${n}`,
    maxFileLength: (len: number, max: number) =>
      `Ha elegido ${len} archivos, el número máximo permitido es ${max}.`,
    maxFileSize: (maxSize: number) =>
      `El tamaño del archivo es demasiado grande. Seleccione un archivo con un tamaño de ${
        maxSize / (1024 * 1024)
      }MB o menos.`,
  },
};

export default { Messages };
